import React, {Component} from 'react';
import Header from "../Header";
import AppNavbar from "../Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import axios from "axios";
import 'react-data-table-component-extensions/dist/index.css';

export default class PortfolioMonthlySummary extends Component {


    constructor (props) {
        super(props)
        this.state = {
            loggedInUser:null,
            monthID: '1',
            yearID: '2024',
            userViewInfo: []
        };
        this.handleToYear = this.handleToYear.bind(this);
        this.handleToMonth = this.handleToMonth.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleToYear(event) {
        console.log("Changed Value for Date-----",event.target.value)
        this.setState({
            yearID: event.target.value
        });
    }


    handleToMonth(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            monthID: event.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        console.log(this.state.monthID,"FromDate ---- ----Todate ------terminalId",this.state.yearID,this.state.userId);
        if(this.state.monthID === '' || this.state.yearID === ''){
            alert(" Please provide valid  Date !!")
            return false;
        }
        if (this.state.disabled) {
            return;
        }
       // this.setState({disabled: true});
        axios({
            url: 'downloadPOSPortfolioSummaryReport?Month='+this.state.monthID+"&Year="+this.state.yearID, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'POSPortfolioSummary.xls'); //or any other extension
            document.body.appendChild(link);
            link.click();
            //this.setState({disabled: false});
        });
    }

    render() {

        const alignBox = {
            display: "flex",
            justifyContent: "space-around"
        };

        const terminalList = this.state.userViewInfo.map((i) => {
            return <option value={i.userId}>{i.userId}</option>;
        });
        terminalList.unshift(<option value={this.state.loggedInUser}>{this.state.loggedInUser}</option>)

        return (
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar data={this.state}/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="DataStream Version 2.0" />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Report Management</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="form-group">
                                                <form onSubmit={ this.handleSubmit }>
                                                    <div className="form-group" style={alignBox}>
                                                        <div>
                                                            <label  className="control-label">Month: </label>
                                                            <select name="monthID" id="monthID" className="custom-select" onChange={this.handleToMonth} >
                                                                <option selected="selected" value="1">January</option>
                                                                <option value="2">February</option>
                                                                <option value="3">March</option>
                                                                <option value="4">April</option>
                                                                <option value="5">May</option>
                                                                <option value="6">June</option>
                                                                <option value="7">July</option>
                                                                <option value="8">August</option>
                                                                <option value="9">September</option>
                                                                <option value="10">October</option>
                                                                <option value="11">November</option>
                                                                <option value="12">December</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label  className="control-label">Year: </label>
                                                            <select name="yearID" id="yearID" className="custom-select" onChange={this.handleToYear} >
                                                                <option value="2028">2028</option>
                                                                <option value="2027">2027</option>
                                                                <option value="2026">2026</option>
                                                                <option value="2025">2025</option>
                                                                <option selected="selected" value="2024">2024</option>
                                                                <option value="2023">2023</option>
                                                                <option value="2022">2022</option>
                                                                <option value="2021">2021</option>
                                                                <option value="2020">2020</option>
                                                                <option value="2019">2019</option>
                                                                <option value="2018">2018</option>
                                                                <option value="2017">2017</option>
                                                                <option value="2016">2016</option>
                                                                <option value="2015">2015</option>
                                                                <option value="2014">2014</option>
                                                                <option value="2013">2013</option>
                                                                <option value="2012">2012</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="btn btn-primary" onClick={this.handleClick} disabled={this.state.disabled} >Generate Report</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </body>
        );
    }
}